export default "https://cdn-static.gokick.com/assets/e732fce3df71ad981aa0ee65436659b369042414/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";